import { render, staticRenderFns } from "./TradeDetailDialog.vue?vue&type=template&id=0b3e5f54&scoped=true"
import script from "./TradeDetailDialog.vue?vue&type=script&lang=js"
export * from "./TradeDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TradeDetailDialog.vue?vue&type=style&index=0&id=0b3e5f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e5f54",
  null
  
)

export default component.exports